<template>
  <ErrorModal v-if="hasModalError" />
  <main class="main-tag">
    <div style="min-height: 70vh" class="row mt-5 login-page">
      <div class="col-md-4 offset-md-4 col-sm-8 offset-sm-2 text-left q-pt-xl">
        <div class="row mb-4">
          <div class="col-md-12 q-pt-xl">
            <q-form @submit="submitCode" class="q-gutter-md">
              <div class="q-pt-lg">
                <q-input
                  v-model="code"
                  bg-color="white"
                  :label="t('mfa.input_result_verify')"
                  dense
                  borderless
                  autofocus
                />
              </div>
              <div class="q-pt-lg">
                <q-btn
                  :label="t('mfa.verify_code')"
                  type="submit"
                  class="mfa-btn bold-font"
                  no-caps
                  color="#0a1f8f"
                />
              </div>
            </q-form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import axiosUrl from "../services/axios.service";
import { useI18n } from "vue-i18n";
import authService from "../services/auth.service";
import ErrorModal from "./ErrorModal.vue";
import store from "../store/index.js";

const API_URL = axiosUrl.getAxiosUrl();

export default {
  components: {
    ErrorModal,
  },
  name: "Mfa",
  setup() {
    store.commit("auth/setIsLoggedIn", false);
    const { t } = useI18n();
    const router = useRouter();
    const code = ref("");

    const hasModalError = computed({
      get: () => store.state.auth.hasModalError,
    });

    const submitCode = async () => {
      await axios
        .post(API_URL + "/MFA/mfaverifycode", {
          code: code.value,
        })
        .then(async () => {
          let returnUrl = router.currentRoute.value.query.returnUrl || "";
          await authService.getAuthUserData(true, returnUrl).then(async () => {
            await authService.handleLoginRedirect();
          });
        })
        .catch(() => {
          store.commit("auth/updateModalError", "MFA code incorrect");
          store.commit("auth/enableModalError");
          code.value = "";
        });
    };

    return {
      t,
      router,
      submitCode,
      hasModalError,
      code,
    };
  },
};
</script>
<style>
.ptl {
  padding-top: 100px;
}
</style>
